import React, { useMemo } from "react";
import { Modal, Table, Text, ScrollArea } from "@mantine/core";
import { getEntityLabel } from "../../data/mcaEntities";
import { getMcaWatchFieldExplanations } from "./mcaWatchFieldLabels";

const McaWatchFieldExplanationModal = ({
  opened,
  onClose,
  entityKey,
  fieldPaths = [],
}) => {
  const rows = useMemo(
    () => getMcaWatchFieldExplanations(entityKey, fieldPaths),
    [entityKey, fieldPaths]
  );

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Watch Field Guide — ${getEntityLabel(entityKey) || "Entity"}`}
      size="lg"
    >
      <Text size="sm" color="dimmed" mb="md">
        Field paths with English and Chinese labels to help configure watch fields.
      </Text>
      <ScrollArea h={480}>
        <Table striped highlightOnHover withBorder verticalSpacing="sm">
          <thead>
            <tr>
              <th>Field</th>
              <th>English</th>
              <th>中文</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.field}>
                <td>
                  <Text size="sm" weight={500}>
                    {row.field}
                  </Text>
                </td>
                <td>
                  <Text size="sm">{row.english}</Text>
                </td>
                <td>
                  <Text size="sm">{row.chinese}</Text>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ScrollArea>
    </Modal>
  );
};

export default McaWatchFieldExplanationModal;
